import { Stack } from "@mui/material";
import { useAtomValue } from "jotai";
import { useNotificationCenterRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { DashboardDataSection } from "web_myplann/Dashboard/Components/DashboardDataSection";
import { DashboardNotificationsSection } from "web_myplann/Dashboard/Components/DashboardNotificationsSection";
import { DashboardSkeleton } from "web_myplann/Dashboard/Components/DashboardSkeleton";
import { rightsState } from "web_myplann/Shared/State/rightsAtom";

type DashboardMainSectionProps = {
	onEmptyChange?: (isEmpty: boolean) => void;
};

export const DashboardMainSection = ({
	onEmptyChange,
}: DashboardMainSectionProps) => {
	const isPending = useAtomValue(rightsState) === undefined;
	const hasNotificationCenterRight = useNotificationCenterRightOptional();

	if (isPending) {
		return (
			<Stack px={1.6} pt={2.4} gap={1}>
				<DashboardSkeleton height={150} />
			</Stack>
		);
	}

	if (hasNotificationCenterRight) {
		return <DashboardNotificationsSection onEmptyChange={onEmptyChange} />;
	}

	return <DashboardDataSection onEmptyChange={onEmptyChange} />;
};
